<!--
 * @Author: 邱扬
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-09-17 20:28:23
 * @LastEditTime: 2021-11-03 11:21:00
-->
<template>
  <div class="null-box">
    <img :src="config.img" alt="no-data">
    <div class="no-data-text">{{ config.text }}</div>
  </div>
</template>

<script>
import nodata from 'assets/images/nodata.svg'
export default {
  name: 'NullData',
  //import 引入组件
  props:{
    warning:{
      type:String,
      default:'No Data'
    },
    config:{
      type:Object,
      default: () => {
        return {
          img:nodata, 
          text: 'No Data', 
        };
      }
    },
  },
  setup(){
    return {nodata}
  }
}
</script>
  
<style scoped lang="scss">

.null-box {
  text-align: center;
  margin-top: 30%;

  .no-data-text {
    font-size: 16px;
    font-weight: 400;
    margin-top: 14px;
    color: #6153ff;
  }
}

</style>